import { useMemo } from 'react';

import { FeatureFlags, useShowFeatureStatus } from '@givebacks/api/feature';

import { useInternalToolsMenu } from '../../internalTools/useInternalMenu';
import { useFeaturesContext_Core } from '../factory';

const useFeatureApiAccess = ({
  featureId,
  causeId: _causeId,
}: {
  featureId: FeatureFlags;
  causeId?: string;
}) => {
  const { getToolValue, isToolsLoading } = useInternalToolsMenu();
  const { causeId } = useFeaturesContext_Core();
  const { data: featureFlag, isLoading: isLoadingFeatureFlag } = useShowFeatureStatus({
    flagId: featureId,
    causeId: _causeId || causeId,
  });

  const isEnabled = useMemo(() => {
    if (import.meta.env.VITE_API_ENV !== 'production' && getToolValue('feature-flag-override')) {
      return true;
    }
    return Boolean(featureFlag?.on);
  }, [featureFlag?.on, getToolValue]);

  const isLoading = useMemo(
    () => isToolsLoading || isLoadingFeatureFlag,
    [isToolsLoading, isLoadingFeatureFlag]
  );

  return {
    isEnabled,
    isLoading,
  };
};

export { useFeatureApiAccess };
